// Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {TranslateService} from '@ngx-translate/core';


const SCOPE_ENUM_USER = 1;
const SCOPE_ENUM_SUB = 2;
const SCOPE_ENUM_RECOVERY = 3;

export interface ISessionInfo {
  scope: number;
  scopeDisplay?: string;
  uuid: string;
  info: string;
  hasPrivateKey: boolean;
  hasProtectedKey: boolean;
}

export interface ISessionResponse {
  sessions: ISessionInfo[];
}

export interface IHeaderInfo {
  filename: string;
  sessionCount: number;
  sessions: ISessionInfo[];
}

@Component({
    selector: 'app-header-info',
    templateUrl: './header-info.component.html',
    styleUrls: ['./header-info.component.scss'],
    standalone: false
})

export class HeaderInfoComponent implements OnInit {

  headerInfo: IHeaderInfo;

  fHeader: string;
  fNoSession: string;
  fSessions: string;
  fScope: string;
  fUUID: string;
  fInfo: string;
  fPrivate: string;
  fProtected: string;
  fClose: string;
  constructor(public dialogRef: MatDialogRef<HeaderInfoComponent>,
              private translate: TranslateService,
              @Inject(MAT_DIALOG_DATA) public data: IHeaderInfo) {
    this.translate.get(['H_HEADER', 'H_NONE', 'H_SESSIONS', 'H_SCOPE', 'H_UUID', 'H_INFO', 'H_PRIVATE', 'H_CLOSE']).subscribe(vals => {
      this.fHeader = vals['H_HEADER'];
      this.fNoSession = vals['H_NONE'];
      this.fSessions = vals['H_SESSIONS'];
      this.fScope = vals['H_SCOPE'];
      this.fUUID = vals['H_UUID'];
      this.fInfo = vals['H_INFO'];
      this.fPrivate = vals['H_PRIVATE'];
      this.fProtected = vals['H_PROTECTED'];
      this.fClose = vals['H_CLOSE'];
    });
    this.headerInfo = data;

    for ( const session of data.sessions ) {
        if ( session.scope === SCOPE_ENUM_USER ) {
          session.scopeDisplay = 'User';
        } else if ( session.scope === SCOPE_ENUM_SUB ) {
          session.scopeDisplay = 'Subscription';
        } else if ( session.scope === SCOPE_ENUM_RECOVERY ) {
          session.scopeDisplay = 'Recovery';
        } else {
          session.scopeDisplay = session.scope.toString(10);
        }
    }

  }

  ngOnInit(): void {
  }

  close() {
    this.dialogRef.close();
  }
}
